import Axios from 'axios-observable';
import { token } from 'services/token';
import { windowObj } from '@lib/common';

const DELI_BASE_URL = windowObj.RAZZLE_VCMS_API_URL + '/api/v1';
export const DELI_ENV_BASE_URL = windowObj.RAZZLE_VCMS_API_URL;
const PINT_BASE_URL = windowObj.RAZZLE_VTR_PINT_BACKEND;
const DELI_BASE_URL_V2 = windowObj.RAZZLE_VCMS_API_URL + '/api/v2';
const DELI_BASE_URL_V3 = windowObj.RAZZLE_VCMS_API_URL + '/api/v3';
const COSMOS_BASE_URL = windowObj.RAZZLE_COSMOS_BACKEND;

const SERVICE_ENGINE_BASE_URL = windowObj.RAZZLE_SERVICE_ENGINE_BASE_URL;

export const http = token.configureHttp(Axios.create({ baseURL: DELI_BASE_URL }));
export const http_v2 = token.configureHttp(Axios.create({ baseURL: DELI_BASE_URL_V2 }));
export const http_v3 = token.configureHttp(Axios.create({ baseURL: DELI_BASE_URL_V3 }));
export const pintHttp = token.configureHttp(
  Axios.create({
    baseURL: PINT_BASE_URL,
  })
);
export const DELI_BASE_URL_V1 = DELI_BASE_URL
export const cosmosHttp = Axios.create({ baseURL: COSMOS_BASE_URL });

// No Authentication yet, so not configured to use token.
export const serviceEngineHttp = Axios.create({ baseURL: SERVICE_ENGINE_BASE_URL });
export const awsHttp = token.configureHttp(
  Axios.create({
    baseURL: '',
  })
);